export default __webpack_public_path__ + "static/flooredape-92600db3b028df4cd2701b5b116cfab9.jpg";